import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import AssetSelectorInput from '../../containers/asset-selector-item-input.jsx';
import styles from './asset-selector-item.css';
import iconFont from '../../css/iconfont.css';

const AssetSelectorItem = props => (
    <div
        className={classNames(styles.spriteSelectorItem, {
            [styles.isSelected]: props.selected
        })}
        onClick={props.onItemClick}
        onMouseDown={props.onMouseDown}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
    >
        {typeof props.number === 'undefined' ? null : (
            <div className={styles.number}>{props.number}</div>
        )}
        <img
            className={styles.spriteImage}
            src={props.costumeURL}
        />
        <div className={styles.spriteInfo}>
            <div className={styles.inputBox}>
                <AssetSelectorInput
                    small
                    type="text"
                    value={props.name}
                    onSelect={props.onItemClick}
                    onSubmit={props.onChangeName}
                />
            </div>
        </div>
        <div
            className={styles.controls}
        >
            {props.assetType === 'sound' ?
                <div
                    className={styles.button}
                    onClick={props.isPlaying && props.selected ? props.onStopButtonClick : props.onPlayButtonClick}
                >
                    {props.isPlaying && props.selected ?
                        <i className={classNames(iconFont.iconfont, iconFont.iconZanting)} /> :
                        <i className={classNames(iconFont.iconfont, iconFont.iconBofang)} />}
                </div> : null
            }
            {props.assetType === 'sound' ?
                <div
                    className={styles.button}
                    onClick={props.onEditButtonClick}
                >
                    <i className={classNames(iconFont.iconfont, iconFont.iconJianqie)} />
                </div> : null
            }
            {props.assetType === 'sound' ?
                null : <div
                    className={styles.button}
                    onClick={props.onCopyButtonClick}
                >
                    <i className={classNames(iconFont.iconfont, iconFont.iconFuzhi)} />
                </div>
            }
            {props.assetType === 'sound' ?
                null : <div
                    className={styles.button}
                    onClick={props.onEditButtonClick}
                >
                    <i className={classNames(iconFont.iconfont, iconFont.iconBianji)} />
                </div>
            }
            {props.onDeleteButtonClick && (<div
                className={styles.button}
                onClick={props.onDeleteButtonClick}
            >
                <i className={classNames(iconFont.iconfont, iconFont.iconShanchu)} />
            </div>)}
        </div>
    </div>
);

AssetSelectorItem.propTypes = {
    assetType: PropTypes.oneOf(['costume', 'backdrop', 'sound']),
    costumeURL: PropTypes.string,
    isPlaying: PropTypes.bools,
    name: PropTypes.string.isRequired,
    number: PropTypes.number,
    onChangeName: PropTypes.func,
    onCopyButtonClick: PropTypes.func,
    onDeleteButtonClick: PropTypes.func,
    onEditButtonClick: PropTypes.func,
    onItemClick: PropTypes.func,
    onMouseDown: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onPlayButtonClick: PropTypes.func.isRequired,
    onStopButtonClick: PropTypes.func.isRequired,
    selected: PropTypes.bool.isRequired
};

export default AssetSelectorItem;
